import Typography from '@components/basics/typography';
import * as React from 'react';
import { Translate } from 'react-localize-redux';

interface NotificationWalletWithdrawlTemplateProps {
  sourceAmount: number;
  sourceCurrency: string;
  destAmount: number;
  destCurrency: string;
  templateName: string;
}

export const NotificationWalletWithdrawlTemplate: React.FC<
  NotificationWalletWithdrawlTemplateProps
> = (props) => {
  const {
    sourceAmount,
    sourceCurrency,
    destAmount,
    destCurrency,
    templateName,
  } = props;
  const currencyToSymbol = (currency: string) => {
    let symbol = '';
    switch (currency) {
      case 'USD':
        symbol = '$';
        break;
      default:
        symbol = '';
        break;
    }
    return symbol;
  };
  const formatAmount = (sourceAmount: number) => {
    return parseFloat(sourceAmount.toString()).toFixed(2);
  };
  return (
    <>
      <Typography>
        {templateName === 'wallet-withdrawl-pending' && (
          <Translate
            id="NOTIFICATION.WALLET_WITHDRAWL_SUBMIT"
            data={{
              DESTAMOUNT: destAmount,
              DESTCURRENCY: destCurrency,
              SOURCECURRENCY: currencyToSymbol(sourceCurrency),
              SOURCEAMOUNT: formatAmount(sourceAmount),
            }}
          />
        )}

        {templateName === 'wallet-withdrawl-succeeded' && (
          <Translate
            id="NOTIFICATION.WALLET_WITHDRAWL_SUCCESS"
            data={{
              DESTAMOUNT: destAmount,
              DESTCURRENCY: destCurrency,
              SOURCECURRENCY: currencyToSymbol(sourceCurrency),
              SOURCEAMOUNT: formatAmount(sourceAmount),
            }}
          />
        )}

        {templateName === 'wallet-withdrawl-failed' && (
          <Translate
            id="NOTIFICATION.WALLET_WITHDRAWL_FAIL"
            data={{
              DESTAMOUNT: destAmount,
              DESTCURRENCY: destCurrency,
              SOURCECURRENCY: currencyToSymbol(sourceCurrency),
              SOURCEAMOUNT: formatAmount(sourceAmount),
            }}
          />
        )}
      </Typography>
    </>
  );
};

export default NotificationWalletWithdrawlTemplate;
